import { enqueueSnackbar } from "../store/actions/snackbarSlice";
import store from "../store/store";

export const dispatchSnackBarMessage = (key, message, severity) => {
  store.dispatch(
    enqueueSnackbar({
      key: key,
      message: message,
      severity: severity,
    })
  );
};
